<div>
  <button
    class="filters-button"
    id="filters-button"
    type="button"
    [ngClass]="{ active: (hasFilters$ | async) }"
    mat-stroked-button
    (click)="toggleVisibility()"
  >
    <mat-icon class="small-icon" svgIcon="sliders"></mat-icon>
    Filters
  </button>
  <div
    id=""
    class="filters-dropdown"
    [class.hide]="(visible$ | async) === false"
  >
    <form id="urgencies-filters-form" [formGroup]="urgenciesForm">
      <h5>Urgency</h5>
      <div class="row">
        <div class="col">
          <mat-checkbox
            id="stroke-filter-checkbox"
            formControlName="Stroke"
            (change)="changeUrgency($event, 'Stroke')"
            >Stroke</mat-checkbox
          >
        </div>
        <div class="col">
          <mat-checkbox
            id="trauma-filter-checkbox"
            formControlName="Trauma"
            (change)="changeUrgency($event, 'Trauma')"
            >Trauma</mat-checkbox
          >
        </div>
      </div>
    </form>
    <hr />
    <form
      id="referring-doctors-filters-form"
      [formGroup]="doctorsForm"
      *ngIf="doctorsFormLoaded$ | async"
    >
      <h5>Requesting Doctor</h5>
      <div
        *ngFor="
          let referringDoctor of referringDoctors;
          let i = index;
          let even = even
        "
      >
        <div class="row" *ngIf="even">
          <div class="col">
            <mat-checkbox
              [formControlName]="referringDoctors[i]"
              (change)="changeDoctor($event, referringDoctors[i])"
            >
              {{ referringDoctors[i] }}
            </mat-checkbox>
          </div>
          <div class="col" *ngIf="referringDoctors.length > i + 1">
            <mat-checkbox
              [formControlName]="referringDoctors[i + 1]"
              (change)="changeDoctor($event, referringDoctors[i + 1])"
            >
              {{ referringDoctors[i + 1] }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </form>
    <div class="filters-footer">
      <div class="row">
        <div class="col">
          <button
            mat-stroked-button
            id="apply-filters-button"
            class="submit"
            [disabled]="(dirty$ | async) === false"
            (click)="submitFilters()"
          >
            Apply Filter
          </button>
        </div>
        <div class="col">
          <button
            mat-stroked-button
            id="clear-filters-button"
            class="clear"
            [disabled]="
              (hasFilters$ | async) === false && (dirty$ | async) === false
            "
            (click)="clearFilters()"
          >
            Clear Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
